import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { baseUrl } from "../../utils/constants";
import { toastContainer } from "../../utils/toast";

const EnterpriseQrCode = ({ orgId }) => {
  if (!orgId) return null;

  const qrUrl = `${baseUrl().replace(
    /\/$/,
    ""
  )}/employee-register?orgId=${orgId}`;

  const downloadQRCode = () => {
    const canvas = document.querySelector("#enterprise-qrcode-canvas");
    if (!canvas) throw new Error("<canvas> not found in the DOM");
    toastContainer("QR code downloaded.", "success");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "Enterprise QR code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div style={{ textAlign: "start", margin: "10px 0" }}>
      <QRCodeCanvas
        id="enterprise-qrcode-canvas"
        level="H"
        size={100}
        value={qrUrl}
      />
      <div>
        <div className="mt-1 cursor-pointer" style={{ color: "#5099DE" }}>
          <span onClick={downloadQRCode}>Download QR Code</span>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseQrCode;
